import { ROUTE_PATH } from 'routes';
import Layout from 'components/Layout';
import { useNavigate, Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import CmsBlocks from 'components/CmsBlocks/v2';
import Button from 'components/UI/Button';
import useLiterals from 'utils/hooks/useLiterals';
import useFeatureGate from 'utils/hooks/useFeatureGate';
import { FEATURE_REGISTRATION } from 'constants/featureGates';
import './styles.scss';

const Onboarding = () => {
  const { authenticated } = useSelector((state) => state.session);
  const literals = useLiterals('onboarding');
  const navigate = useNavigate();
  // Registro disponible en todas las plataformas; en desktop solo ofrece el
  // camino de cliente existente (WEB_MLS-608).
  const registrationEnabled = useFeatureGate(FEATURE_REGISTRATION);

  useEffect(() => {
    if (authenticated) {
      navigate(ROUTE_PATH.HOME);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (authenticated) {
    return null;
  }

  return (
    <Layout className='onboarding-layout'>
      <div className='onboarding-wrapper'>

        {/* Content panel — carousel + CTAs */}
        <div className='full-screen-container with-header onboarding-content'>
          <div className='screen-content carousel-container'>
            <CmsBlocks />
          </div>
          <div className='screen-actions'>
            <Button
              text={literals.initSession}
              to={ROUTE_PATH.LOGIN}
            />
            {registrationEnabled && (
              <div className='text-center mt-2'>
                <p className='mb-1'>{literals.common.noAccount}</p>
                <Link
                  to={ROUTE_PATH.setRegistration()}
                  className='uppercase text-primary font-semibold'
                >
                  {literals.common.registerHere}
                </Link>
              </div>
            )}
          </div>
        </div>

      </div>
    </Layout>
  );
};

export default Onboarding;
